import client from "./client"; // ajuste o caminho se necessário

export async function uploadFileToS3(file, folder = "") {
  const res = await client.post("/generate-upload-url", {
    fileName: file.name,
    fileType: file.type,
    folder,
  });

  const { uploadURL, fileUrl } = res.data;

  const uploadRes = await fetch(uploadURL, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!uploadRes.ok) {
    throw new Error("Erro ao enviar o arquivo para o S3");
  }

  return fileUrl;
}
